import React from "react";
import styled from "styled-components";

import BANNER_IMAGE from "assets/images/baoku/baoku_banner.jpg";
import { SCREEN_SM } from "sketon/ui/theme";

const SytledWrapper = styled.div`
  display: flex;
  width: 100%;
`;

const StyledBannerContainer = styled.div`
  width: 100%;
  margin-top: 0;
  margin-left: 0;
  padding: 0 0 0 0;
  border-radius: 0;

  margin-bottom: 20px;

  position: relative;

  @media (max-width: ${SCREEN_SM}) {
    margin-bottom: 0.2rem;
  }
`;

/* The 2880x800 source is reserved via aspect-ratio so the banner occupies its
   final height before the JPEG decodes, instead of collapsing to 0 and popping.
   The warm fill matches the artwork's background while it loads. */
const StyledBannerDiv = styled.img`
  width: 100%;
  display: block;
  aspect-ratio: 18 / 5;
  background-color: #F7EDD8;
`;

interface BSBannerViewProps {}
export const BSBannerView: React.FC<BSBannerViewProps> = () => {
  return (
    <SytledWrapper>
      <StyledBannerContainer>
        <StyledBannerDiv src={BANNER_IMAGE}></StyledBannerDiv>
      </StyledBannerContainer>
    </SytledWrapper>
  );
};
